import React, {Component} from 'react';
import {Button, Card, Modal, Tooltip} from "antd";
import {withBreadcrumbCurried} from "../Boilerplate/BreadcrumbContext";
import {compose} from "redux";
import {connect} from "react-redux";
import {ContactCard_View} from "../Boilerplate/ContactCard";
import {initiatePasswordReset, leaveCompany} from "../../actions/users";
import LinkButton from "../Boilerplate/LinkButton";
import {getCompanyEmployees} from "../../actions/companies";
import {withTransparentLoading} from "../Boilerplate/deferLoaderHoc";

class Profile extends Component {
  showConfirm = () => {
    const { onLeave } = this.props;
    Modal.confirm({
      title: 'Are you sure you want to leave your company?',
      content: 'If you leave your company, you will be logged out and will have to create a new company or request to' +
        ' join an existing one to log back in!',
      onOk: () => onLeave && onLeave(),
      onCancel() {},
    })
  };

  render() {
    const { employees, profile, onChangePassword } = this.props;
    const list = Object.values(employees);
    const canRemoveSelf = !profile.companyadmin || list.filter(e => e.companyadmin).length > 1 || list.length === 1;
    return (
      <Card
        title={<h1>Profile</h1>}
        extra={<React.Fragment>
          <Button.Group>
            <Tooltip title={!canRemoveSelf ? 'You must appoint another admin before you can leave your company' : ''}>
              <Button disabled={!canRemoveSelf} onClick={this.showConfirm}>Leave Company</Button>
            </Tooltip>
            <LinkButton type={'edit'} to={'/settings/profile/edit'}>Edit</LinkButton>
          </Button.Group>
        </React.Fragment>}
      >
        <ContactCard_View user={{resource: profile}}/>
        <br />
        <Tooltip title={'Email me a link to change my password'}>
          <Button onClick={() => onChangePassword && onChangePassword(profile.email)}>Update Password</Button>
        </Tooltip>
      </Card>
    );
  }
}

export default compose(
  withBreadcrumbCurried({ title: 'User Profile', path: '/settings/profile' }),
  connect(
    (state, props) => ({
      profile: state.profile,
      employees: state.employees,
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyEmployees()),
      onChangePassword: email => dispatch(initiatePasswordReset(email)),
      onLeave: () => dispatch(leaveCompany()),
    })
  ),
  withTransparentLoading,
)(Profile);



// WEBPACK FOOTER //
// ./src/components/Settings/Profile.js